export type CaseChecklistTone = 'rose' | 'amber';

export interface CaseChecklistItem {
    readonly id: string;
    readonly label: string;
}

export interface CaseChecklistSection {
    readonly id: string;
    readonly number: number;
    readonly title: string;
    readonly views: string;
    readonly tone: CaseChecklistTone;
    readonly items: readonly CaseChecklistItem[];
}

export interface CaseChecklistPayload {
    confirmed: true;
}

export const CASE_CHECKLIST_SECTIONS: readonly CaseChecklistSection[] = [
    {
        id: 'anterior',
        number: 1,
        title: 'Anterior',
        views: 'Frontal and anterior open views',
        tone: 'rose',
        items: [
            {
                id: 'anterior_leveling',
                label: 'Anterior leveling: canines and centrals at the same level; laterals slightly above. No cant.'
            },
            {
                id: 'overjet',
                label: 'Overjet: visible clearance between upper and lower incisors, not edge-to-edge, not underbite.'
            },
            {
                id: 'anterior_open_bite',
                label: 'No anterior open bite. Incisors overlap as planned.'
            },
            { id: 'overbite', label: 'Overbite depth: overbite according to plan.' },
            {
                id: 'midlines',
                label: 'Midlines: upper and lower coincident or according to plan.'
            },
            { id: 'anterior_spaces', label: 'Anterior spaces: no remaining spaces.' }
        ]
    },
    {
        id: 'posterior',
        number: 2,
        title: 'Posterior',
        views: 'Lateral and occlusal views',
        tone: 'rose',
        items: [
            { id: 'posterior_open_bite', label: 'No posterior open bite (POB).' },
            {
                id: 'crossbite',
                label: 'Crossbite: corrected as planned, or functional crossbite deliberately left as instructed.'
            },
            {
                id: 'canine_molar',
                label: 'Canine and molar relationship: not visibly worse than plan.'
            },
            { id: 'buccal_corridors', label: 'Buccal corridors: symmetric right to left.' }
        ]
    },
    {
        id: 'alignment',
        number: 3,
        title: 'Alignment & arch',
        views: 'Occlusal views',
        tone: 'amber',
        items: [
            {
                id: 'rotations',
                label: 'Rotations: no tooth still visibly rotated unless the doctor acknowledges the rotation.'
            },
            { id: 'spaces', label: 'Spaces: all closed.' },
            { id: 'crowding', label: 'Crowding: no crowding present.' },
            { id: 'arch_form', label: 'Arch form: smooth and symmetric.' }
        ]
    }
];
